document.addEventListener("DOMContentLoaded", () => {
  const HEADER_OFFSET = 120; // Change this to match your sticky header

  // Generate IDs from accordion headings
  document.querySelectorAll("details").forEach((details) => {
    const summary = details.querySelector("summary");
    if (!summary) return;

    const id = summary.textContent
      .trim()
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-");

    details.id = id;

    // Add offset for sticky header
    details.style.scrollMarginTop = `${HEADER_OFFSET}px`;
  });

  function openAndScroll(hash, updateHistory = false) {
    if (!hash) return;

    const target = document.querySelector(hash);
    if (!target) return;

    // Open the accordion
    if (target.tagName.toLowerCase() === "details") {
      target.open = true;
    }

    // Wait a bit for the accordion to expand
    setTimeout(() => {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      if (updateHistory) {
        history.replaceState(null, "", hash);
      }
    }, 120);
  }

  // Open accordion if page loads with a hash
  openAndScroll(window.location.hash);

  // Smooth scroll for internal links
  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const hash = link.getAttribute("href");

    if (!document.querySelector(hash)) return;

    e.preventDefault();
    openAndScroll(hash, true);
  });
});

document.addEventListener("DOMContentLoaded", () => {
  if (window.location.pathname.startsWith("/policies/")) {
  document.body.classList.add("policy-page");
}
});
